const couples = [
  {
    prop1: {
      name: "Tensile Strength",
      property: "tensileStrength",
      intervalMPa: 10,
      intervalKsi: 5,
      MPaKSI: true
    },
    prop2: {
      name: "Elongation (%)",
      property: "elongation",
      interval: 2
    }
  },
  {
    prop1: {
      name: "Hardness (HV)",
      property: "hardnessHV",
      interval: 10
    },
    prop2: {
      name: "Machinability (%)",
      property: "machinability",
      interval: 2
    }
  },
  {
    prop1: {
      name: "Yield Strength",
      property: "yieldStrength",
      intervalMPa: 10,
      intervalKsi: 5,
      MPaKSI: true
    },
    prop2: {
      name: "Electrical Conductivity (%IACS)",
      property: "electricalConductivityIACS",
      interval: 1
    }
  },
  {
    prop1: {
      name: "Thermal Conductivity (W/m/K)",
      property: "thermalConductivity",
      interval: 5
    },
    prop2: {
      name: "Electrical Conductivity (%IACS)",
      property: "electricalConductivityIACS",
      interval: 1
    }
  },
  {
    prop1: {
      name: "Hardness (HB)",
      property: "hardnessHB",
      interval: 5
    },
    prop2: {
      name: "Density (g/cm3)",
      property: "density",
      interval: 0.05
    }
  },
  {
    prop1: {
      name: "Thermal Conductivity (W/m/K)",
      property: "thermalConductivity",
      interval: 5
    },
    prop2: {
      name: "Yield Strength",
      property: "yieldStrength",
      intervalMPa: 10,
      intervalKsi: 5,
      MPaKSI: true
    }
  }
];

export default couples;
